module.exports = __webpack_public_path__ + "static/media/orders-shot-1.b495b612.png";